module.exports = __webpack_public_path__ + "img/Small.f1d3f96b.png";